import React, { Component } from "react";
import { Button, Container, Row, Form, Col, Offcanvas } from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import configData from "../config.json";

import LoadingOverlay from "./LoadingOverlay";
export default class Caresupremesuminsuredcodes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",
      show: false,
      data: [],
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      errors: {},
      filteredData: null,
      tableClms: [
        {
          name: "S.NO",
          selector: (row, i) => row.caresupremesuminsuredcodes_Id,
          sortable: true,
          cell: (row) => <span>{row.caresupremesuminsuredcodes_Id}</span>,
        },
        {
          name: "Product Name",
          selector: (row, i) => row.productName,
          sortable: true,
          cell: (row) => <span>{row.productName}</span>,
        },
        {
          name: "Base Product ID",
          selector: (row, i) => row.baseProductID,
          sortable: true,
          cell: (row) => <span>{row.baseProductID}</span>,
        },
        {
          name: "Sum Insured Code",
          selector: (row, i) => row.sumInsuredCode,
          sortable: true,
          cell: (row) => <span>{row.sumInsuredCode}</span>,
        },
        {
          name: "Sum Insured Value",
          selector: (row, i) => row.sumInsuredValue,
          sortable: true,
          cell: (row) => <span>{row.sumInsuredValue}</span>,
        },
        {
          name: "Cover Type",
          selector: (row, i) => row.coverType,
          sortable: true,
          cell: (row) => <span>{row.coverType}</span>,
        },
        {
          name: "Description",
          selector: (row, i) => row.description,
          sortable: true,
          cell: (row) => <span>{row.description}</span>,
        },
        {
          name: "Dummy One",
          selector: (row, i) => row.dummyOne,
          sortable: true,
          cell: (row) => <span>{row.dummyOne}</span>,
        },
        {
          name: "Dummy Two",
          selector: (row, i) => row.dummyTwo,
          sortable: true,
          cell: (row) => <span>{row.dummyTwo}</span>,
        },
        {
          name: "Dummy three",
          selector: (row, i) => row.dummyThree,
          sortable: true,
          cell: (row) => <span>{row.dummyThree}</span>,
        },
        {
          name: "Actions",
          sortable: false,
          cell: (row) => (
            <div>
              {/* edit button and delete button */}
              <Button
                variant="primary"
                onClick={() => this.handleEnterEditMode(row)}
                className="bi bi-pen"
                style={{ marginRight: "3px" }}
              ></Button>
              <Button
                variant="danger"
                onClick={() => this.handleDelete(row)}
                className="bi bi-trash danger"
              ></Button>
            </div>
          ),
        },
      ],
      currentPage: 1,
      itemsPerPage: 10,
      productName: "",
      baseProductID: "",
      sumInsuredCode: "",
      sumInsuredValue: "",
      coverType: "",
      description: "",
      dummyOne: "",
      dummyTwo: "",
      dummyThree: "",
      caresupremesuminsuredcodes_Id: "",
      isEditing: false,
      isNewEntry: false,
    };
  }
  //editing data
  handleEnterEditMode = (row) => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    this.setState({
      productName: row.productName,
      baseProductID: row.baseProductID,
      sumInsuredCode: row.sumInsuredCode,
      sumInsuredValue: row.sumInsuredValue,
      coverType: row.coverType,
      description: row.description,
      dummyOne: row.dummyOne,
      dummyTwo: row.dummyTwo,
      dummyThree: row.dummyThree,
      caresupremesuminsuredcodes_Id: row.caresupremesuminsuredcodes_Id,
      isEditing: true,
    });
    // this.setState({ cData: { ...row }, isEditing: true });
  };
  // offcanvas Open
  handleOffcanvasShow = () => {
    this.setState({
      show: true,
      productName: "",
      baseProductID: "",
      sumInsuredCode: "",
      sumInsuredValue: "",
      coverType: "",
      description: "",
      dummyOne: "",
      dummyTwo: "",
      dummyThree: "",
    });
  };
  // Offcanvas close button
  handleOffcanvasClose = () => {
    this.setState({ show: false });
  };
  showToast = (msg, type) => {
    var tType = toast.TYPE.INFO;
    if (type === "success") tType = toast.TYPE.SUCCESS;
    if (type === "error") tType = toast.TYPE.ERROR;
    if (type === "warning") tType = toast.TYPE.WARNING;
    toast(msg, { type: tType });
  };
  CaresupremesuminsuredcodeseditHandler = (e) => {
    e.preventDefault();
    // const updateFormData = {...editFormData};
    // updateFormData['Caresupremesuminsuredcodes_Id'] = e.target.parentElement.getAttribute("id");
    // setEditFormData(updateFormData);
    // setEdit(true);
  };

  CaresupremesuminsuredcodesfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + "C_Caresupremesuminsuredcodes/list", {
      // Enter your IP address here

      method: "POST",
      //headers :{ 'Content-Type' : 'application/json'},
      mode: "cors",
      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ data: data.list });
        }
      });
  };
  CaresupremesuminsuredcodessubmitHandler = (e) => {
    e.preventDefault();
    //   setButtons(contacts);
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("productName", this.state.productName);
    formData.append("baseProductID", this.state.baseProductID);
    formData.append("sumInsuredCode", this.state.sumInsuredCode);
    formData.append("sumInsuredValue", this.state.sumInsuredValue);
    formData.append("coverType", this.state.coverType);
    formData.append("description", this.state.description);
    formData.append("dummyOne", this.state.dummyOne);
    formData.append("dummyTwo", this.state.dummyTwo);
    formData.append("dummyThree", this.state.dummyThree);

    this.setState({ loading: true, loadingMessage: "Saving..." });
    fetch(configData.api_url + "C_Caresupremesuminsuredcodes/add", {
      // Enter your IP address here

      method: "POST",
      //headers :{ 'Content-Type' : 'application/json'},
      mode: "cors",
      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.CaresupremesuminsuredcodesfetchHandler();
          this.handleOffcanvasClose();
          this.setState({
            productName: "",
            baseProductID: "",
            sumInsuredCode: "",
            sumInsuredValue: "",
            coverType: "",
            description: "",
            dummyOne: "",
            dummyTwo: "",
            dummyThree: "",
          });
        }
      
        this.setState({ loading: false });})
    .catch(() => { this.setState({ loading: false }); });
  };
  CaresupremesuminsuredcodesupdateHandler = (e) => {
    e.preventDefault();
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("productName", this.state.productName);
    formData.append("baseProductID", this.state.baseProductID);
    formData.append("sumInsuredCode", this.state.sumInsuredCode);
    formData.append("sumInsuredValue", this.state.sumInsuredValue);
    formData.append("coverType", this.state.coverType);
    formData.append("description", this.state.description);
    formData.append("dummyOne", this.state.dummyOne);
    formData.append("dummyTwo", this.state.dummyTwo);
    formData.append("dummyThree", this.state.dummyThree);
    formData.append(
      "caresupremesuminsuredcodes_Id",
      this.state.caresupremesuminsuredcodes_Id
    );
    this.setState({ loading: true, loadingMessage: "Updating..." });
    fetch(configData.api_url + "C_Caresupremesuminsuredcodes/update", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.CaresupremesuminsuredcodesfetchHandler();
          this.handleOffcanvasClose();
        }
      
        this.setState({ loading: false });})
    .catch(() => { this.setState({ loading: false }); });
  };

  componentDidMount() {
    this.CaresupremesuminsuredcodesfetchHandler();
  }
  handleproductNameChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ productName: fieldValue });
  };
  handlebaseProductIDChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ baseProductID: fieldValue });
  };
  handlesumInsuredCodeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ sumInsuredCode: fieldValue });
  };
  handlesumInsuredValueChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ sumInsuredValue: fieldValue });
  };
  handlecoverTypeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ coverType: fieldValue });
  };
  handledescriptionChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ description: fieldValue });
  };
  handledummyOneChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dummyOne: fieldValue });
  };
  handledummyTwoChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dummyTwo: fieldValue });
  };
  handledummyThreeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dummyThree: fieldValue });
  };
  handleRowSelect = (row) => {
    this.setState({
      selectedRow: row.index,
    });
  };
  handleRowUpdate = (newData, oldData) => {
    const data = [...this.state.data];
    const index = oldData.index;
    data[index] = newData;
    this.setState({ data });
  };

  handleEdit = (row) => {
    console.log(`Editing row with ID ${row.id}`);
    // implement your edit logic here
  };
  handleDelete = (row, index) => {
    var formData = new FormData();
    formData.append(
      "caresupremesuminsuredcodes_Id",
      row.caresupremesuminsuredcodes_Id
    );
    this.setState({ loading: true, loadingMessage: "Deleting..." });
    fetch(configData.api_url + "C_Caresupremesuminsuredcodes/delete", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.CaresupremesuminsuredcodesfetchHandler();
        }
      
        this.setState({ loading: false });})
    .catch(() => { this.setState({ loading: false }); });
  };
  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ itemsPerPage: newPerPage, currentPage: page });
  };

  handleFilter = (e) => {
    const searchValue = e.target.value.toLowerCase();
    const filteredData = this.state.data.filter((row) => {
      return Object.values(row).join(" ").toLowerCase().includes(searchValue);
    });
    this.setState({ filteredData });
  };

  render() {
    const paginatedData = this.state.filteredData
      ? this.state.filteredData.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      )
      : this.state.data.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      );

    return (
      <div className="page-title">
        <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />
        <div className="row">
          <div className="title_left">
            <h2 style={{ textAlign: "start" }}>
              Care Supreme SumInsured Codes
            </h2>
          </div>
          <div className="col-md-12 col-sm-12 col-xs-12">
            <div className="x_panel">
              <div className="x_content">
                <div
                  id="datatable_wrapper"
                  className="dataTables_wrapper form-inline
                                   dt-bootstrap no-footer"
                >
                  <Row className="row">
                    <Col
                      className="d-flex justify-content-end"
                      style={{ marginRight: "5px", marginTop: "20px" }}
                    >
                      <Button
                        variant="primary"
                        className="bi bi-plus "
                        onClick={this.handleOffcanvasShow}
                      >
                        New
                      </Button>
                      <Offcanvas
                        show={this.state.show}
                        onHide={this.handleOffcanvasClose}
                        {...this.props}
                        style={{ width: "500px" }}
                        placement="end"
                        backdrop="true"
                      >
                        <Offcanvas.Header closeButton>
                          <Offcanvas.Title>
                            Caresupremesuminsuredcodes page
                          </Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                          <Container
                            style={{ overflowY: "auto", height: "auto" }}
                          >
                            <Row className="divstyle">
                              <Row>
                                <Form>
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Product Name
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handleproductNameChange}
                                        className="form-control"
                                        name="productName"
                                        value={this.state.productName}
                                        required="required"
                                        placeholder="Enter productName"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.productName}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Base Product ID
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handlebaseProductIDChange
                                        }
                                        className="form-control"
                                        name="baseProductID"
                                        value={this.state.baseProductID}
                                        required="required"
                                        placeholder="Enter baseProductID"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.baseProductID}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Sum Insured Code
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handlesumInsuredCodeChange
                                        }
                                        className="form-control"
                                        name="sumInsuredCode"
                                        value={this.state.sumInsuredCode}
                                        required="required"
                                        placeholder="Enter sumInsuredCode"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.sumInsuredCode}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Sum Insured Value
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handlesumInsuredValueChange
                                        }
                                        className="form-control"
                                        name="sumInsuredValue"
                                        value={this.state.sumInsuredValue}
                                        required="required"
                                        placeholder="Enter sumInsuredValue"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.sumInsuredValue}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Cover Type
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handlecoverTypeChange}
                                        className="form-control"
                                        name="coverType"
                                        value={this.state.coverType}
                                        required="required"
                                        placeholder="Enter coverType"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.coverType}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Description
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handledescriptionChange}
                                        className="form-control"
                                        name="description"
                                        value={this.state.description}
                                        required="required"
                                        placeholder="Enter description"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.description}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Dummy One
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handledummyOneChange}
                                        className="form-control"
                                        name="dummyOne"
                                        value={this.state.dummyOne}
                                        required="required"
                                        placeholder="Enter dummyOne"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.dummyOne}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Dummy Two
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handledummyTwoChange}
                                        className="form-control"
                                        name="dummyTwo"
                                        value={this.state.dummyTwo}
                                        required="required"
                                        placeholder="Enter dummyTwo"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.dummyTwo}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Dummy three
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handledummyThreeChange}
                                        className="form-control"
                                        name="dummyThree"
                                        value={this.state.dummyThree}
                                        required="required"
                                        placeholder="Enter dummyThree"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.dummyThree}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                </Form>
                              </Row>
                            </Row>
                            <Row>
                              <Col
                                className="d-flex justify-content-end"
                                style={{ marginRight: "50px" }}
                              >
                                <Button
                                  className="button"
                                  variant="success"
                                  onClick={
                                    this.CaresupremesuminsuredcodessubmitHandler
                                  }
                                  style={{
                                    marginTop: "20px",
                                  }}
                                >
                                  Save
                                </Button>
                              </Col>
                            </Row>
                          </Container>
                        </Offcanvas.Body>
                      </Offcanvas>
                      {/*offcanvas is over */}
                    </Col>
                  </Row>
                  <br />
                  <div>
                    {" "}
                    {this.state.isEditing && (
                      // Edit Offcanvas
                      <Offcanvas
                        show={this.state.isEditing}
                        onHide={() => this.setState({ isEditing: false })}
                        {...this.props}
                        style={{ width: "500px", height: "auto" }}
                        placement="end"
                        backdrop="true"
                      >
                        <Offcanvas.Header closeButton>
                          <Offcanvas.Title>
                            Edit Care Supreme SumInsured Codes
                          </Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                          <Form className="form-horizontal form-label-left input_mask">
                            <Row>
                              <Col lg="4" md="4">
                                <Form.Label style={{ paddingTop: "8px" }}>
                                  Product Name
                                </Form.Label>
                              </Col>
                              <Col lg="8" md="8">
                                <Form.Control
                                  type="text"
                                  onChange={this.handleproductNameChange}
                                  className="form-control"
                                  name="productName"
                                  value={this.state.productName}
                                  required="required"
                                  placeholder="Enter productName"
                                />
                              </Col>
                              <div
                                className="errorMsg"
                                style={{ color: "red" }}
                              >
                                {" "}
                                {this.state.errors.productName}{" "}
                              </div>
                            </Row>
                            <br />
                            <Row>
                              <Col lg="4" md="4">
                                <Form.Label style={{ paddingTop: "8px" }}>
                                  Base Product ID
                                </Form.Label>
                              </Col>
                              <Col lg="8" md="8">
                                <Form.Control
                                  type="text"
                                  onChange={this.handlebaseProductIDChange}
                                  className="form-control"
                                  name="baseProductID"
                                  value={this.state.baseProductID}
                                  required="required"
                                  placeholder="Enter baseProductID"
                                />
                              </Col>
                              <div
                                className="errorMsg"
                                style={{ color: "red" }}
                              >
                                {" "}
                                {this.state.errors.baseProductID}{" "}
                              </div>
                            </Row>
                            <br />
                            <Row>
                              <Col lg="4" md="4">
                                <Form.Label style={{ paddingTop: "8px" }}>
                                  Sum Insured Code
                                </Form.Label>
                              </Col>
                              <Col lg="8" md="8">
                                <Form.Control
                                  type="text"
                                  onChange={this.handlesumInsuredCodeChange}
                                  className="form-control"
                                  name="sumInsuredCode"
                                  value={this.state.sumInsuredCode}
                                  required="required"
                                  placeholder="Enter sumInsuredCode"
                                />
                              </Col>
                              <div
                                className="errorMsg"
                                style={{ color: "red" }}
                              >
                                {" "}
                                {this.state.errors.sumInsuredCode}{" "}
                              </div>
                            </Row>
                            <br />
                            <Row>
                              <Col lg="4" md="4">
                                <Form.Label style={{ paddingTop: "8px" }}>
                                  Sum Insured Value
                                </Form.Label>
                              </Col>
                              <Col lg="8" md="8">
                                <Form.Control
                                  type="text"
                                  onChange={this.handlesumInsuredValueChange}
                                  className="form-control"
                                  name="sumInsuredValue"
                                  value={this.state.sumInsuredValue}
                                  required="required"
                                  placeholder="Enter sumInsuredValue"
                                />
                              </Col>
                              <div
                                className="errorMsg"
                                style={{ color: "red" }}
                              >
                                {" "}
                                {this.state.errors.sumInsuredValue}{" "}
                              </div>
                            </Row>
                            <br />
                            <Row>
                              <Col lg="4" md="4">
                                <Form.Label style={{ paddingTop: "8px" }}>
                                  Cover Type
                                </Form.Label>
                              </Col>
                              <Col lg="8" md="8">
                                <Form.Control
                                  type="text"
                                  onChange={this.handlecoverTypeChange}
                                  className="form-control"
                                  name="coverType"
                                  value={this.state.coverType}
                                  required="required"
                                  placeholder="Enter coverType"
                                />
                              </Col>
                              <div
                                className="errorMsg"
                                style={{ color: "red" }}
                              >
                                {" "}
                                {this.state.errors.coverType}{" "}
                              </div>
                            </Row>
                            <br />
                            <Row>
                              <Col lg="4" md="4">
                                <Form.Label style={{ paddingTop: "8px" }}>
                                  Description
                                </Form.Label>
                              </Col>
                              <Col lg="8" md="8">
                                <Form.Control
                                  type="text"
                                  onChange={this.handledescriptionChange}
                                  className="form-control"
                                  name="description"
                                  value={this.state.description}
                                  required="required"
                                  placeholder="Enter description"
                                />
                              </Col>
                              <div
                                className="errorMsg"
                                style={{ color: "red" }}
                              >
                                {" "}
                                {this.state.errors.description}{" "}
                              </div>
                            </Row>
                            <br />
                            <Row>
                              <Col lg="4" md="4">
                                <Form.Label style={{ paddingTop: "8px" }}>
                                  Dummy One
                                </Form.Label>
                              </Col>
                              <Col lg="8" md="8">
                                <Form.Control
                                  type="text"
                                  onChange={this.handledummyOneChange}
                                  className="form-control"
                                  name="dummyOne"
                                  value={this.state.dummyOne}
                                  required="required"
                                  placeholder="Enter dummyOne"
                                />
                              </Col>
                              <div
                                className="errorMsg"
                                style={{ color: "red" }}
                              >
                                {" "}
                                {this.state.errors.dummyOne}{" "}
                              </div>
                            </Row>
                            <br />
                            <Row>
                              <Col lg="4" md="4">
                                <Form.Label style={{ paddingTop: "8px" }}>
                                  Dummy Two
                                </Form.Label>
                              </Col>
                              <Col lg="8" md="8">
                                <Form.Control
                                  type="text"
                                  onChange={this.handledummyTwoChange}
                                  className="form-control"
                                  name="dummyTwo"
                                  value={this.state.dummyTwo}
                                  required="required"
                                  placeholder="Enter dummyTwo"
                                />
                              </Col>
                              <div
                                className="errorMsg"
                                style={{ color: "red" }}
                              >
                                {" "}
                                {this.state.errors.dummyTwo}{" "}
                              </div>
                            </Row>
                            <br />
                            <Row>
                              <Col lg="4" md="4">
                                <Form.Label style={{ paddingTop: "8px" }}>
                                  Dummy three
                                </Form.Label>
                              </Col>
                              <Col lg="8" md="8">
                                <Form.Control
                                  type="text"
                                  onChange={this.handledummyThreeChange}
                                  className="form-control"
                                  name="dummyThree"
                                  value={this.state.dummyThree}
                                  required="required"
                                  placeholder="Enter dummyThree"
                                />
                              </Col>
                              <div
                                className="errorMsg"
                                style={{ color: "red" }}
                              >
                                {" "}
                                {this.state.errors.dummyThree}{" "}
                              </div>
                            </Row>
                            <br />
                            <div style={{ float: "right" }}>
                              <button
                                className=" btn btn-warning me-2"
                                style={{
                                  backgroundColor: "#fff",
                                  color: "#000",
                                  borderColor: "#ccc",
                                }}
                                onClick={() =>
                                  this.setState({ isEditing: false })
                                }
                              >
                                Close
                              </button>{" "}
                              <button
                                className="btn btn-primary me-2"
                                style={{
                                  backgroundColor: "#23547e",
                                  color: "#fff",
                                  borderColor: "#2e6da4",
                                }}
                                onClick={
                                  this.CaresupremesuminsuredcodesupdateHandler
                                }
                              >
                                Update
                              </button>
                            </div>
                          </Form>
                        </Offcanvas.Body>
                      </Offcanvas>
                    )}
                  </div>
                  <br />
                  <Row>
                    <div style={{ marginRight: "5px" }}>
                      {/* searchbar,pagination,filter */}
                      <input
                        type="text"
                        style={{ float: "left", marginBottom: "10px" }}
                        onChange={this.handleFilter}
                        placeholder="Search..."
                      />
                      <DataTable
                        data={paginatedData}
                        columns={this.state.tableClms}
                        pagination
                        paginationServer
                        paginationTotalRows={
                          this.state.filteredData
                            ? this.state.filteredData.length
                            : this.state.data.length
                        }
                        onChangeRowsPerPage={this.handlePerRowsChange}
                        onChangePage={this.handlePageChange}
                        paginationRowsPerPageOptions={[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]}
                        paginationPerPage={100}
                        keyField="id"
                        paginationRowsPerPageOptions={[
                          10, 20, 30, 50, 60, 70, 80, 90, 100,
                        ]}
                        className="table table-striped table-bordered dataTable no-footer employeesTableIcons"
                      />
                    </div>
                  </Row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
